import React, { Component, Fragment } from 'react';
import Modal from "react-bootstrap/Modal";
import axios from "axios";
import classnames from "classnames";
import Image from "../../components/Image";
import lazyImages from "../../lazyImages/lazyImages";
import { Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

class GalleryModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            activeImageKey: null,
            images: [],
            carouselIsOpen: false,
        }
        this.container = React.createRef();
        this.intersectObserver = null;
    }

    loadGalleryData() {
        axios
            .get(`/api/location/${this.props.locationId}/media`)
            .then(response => {
                this.setState({
                    images: response.data['location-gallery']
                });
            })
            .catch(error => {
                console.log(error)
            });
    }

    componentDidMount() {
        this.loadGalleryData();
    }

    componentDidUpdate(prevProps, prevState) {
        if (!!this.props.show && !prevProps.show) {
            this.loadGalleryData();
        }

        if (!this.state.carouselIsOpen && this.intersectObserver) {
            this.intersectObserver.disconnect();
        }

        /**
         * scroll to active slide if on the thumb gallery
         */

        if (!this.state.viewerIsOpen && this.state.activeImageKey) {
            let thumb = document.getElementById('thumb-' + this.state.activeImageKey);
            if (thumb) {
                const y = thumb.offsetTop - (window.innerHeight / 2);

                let modalContainer = document.querySelector('.il-thumb-gallery-modal');

                if (modalContainer)
                    modalContainer.scrollTo(
                        {
                            top: y,
                            left: 0,
                        }
                    );
            }
        }
    }

    render() {
        const {
            title = null,
            show = false,
            handleClose = () => { return false; }
        } = this.props;

        const activateCarousel = (key) => {
            this.setState({
                activeImageKey: key,
                carouselIsOpen: true
            })
        }

        const deactivateCarousel = () => {
            this.setState({
                carouselIsOpen: false
            })
        }

        return (
            <Modal
                className="il-thumb-gallery-modal"
                show={show}
                onHide={handleClose}
                onExited={e => {
                    this.setState({
                        carouselIsOpen: false,
                        activeImageKey: null,
                    })
                }}
                onEscapeKeyDown={e => {
                    if (this.state.carouselIsOpen) {
                        e.preventDefault();
                        this.setState({ carouselIsOpen: false })
                    } else {
                        this.setState({ carouselIsOpen: false });
                    }
                }}
            >
                <Modal.Body>
                    <button
                        type="button"
                        data-dismiss="modal"
                        className="close pt-1 pb-2 px-2 position-absolute bg-white shadow rounded-circle"
                        aria-label="Close"
                        style={{ opacity: 1, right: '-10px', top: '-10px', zIndex: 9999 }}
                        onClick={handleClose}>
                        <span aria-hidden="true">&times;</span>
                    </button>
                    {title && (
                        <div className="d-flex justify-content-between pr-3">
                            <h4 className="h2">{title}</h4>
                            {this.state.carouselIsOpen && (
                                <button
                                    className="btn h6 mb-0 py-0 px-0 align-items-center justify-content-center mt-n2"
                                    style={{ zIndex: 100 }}
                                    onClick={deactivateCarousel}
                                >
                                    <svg width="25" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" className="mr-2"><path fill="currentColor" d="M136.97 380.485l7.071-7.07c4.686-4.686 4.686-12.284 0-16.971L60.113 273H436c6.627 0 12-5.373 12-12v-10c0-6.627-5.373-12-12-12H60.113l83.928-83.444c4.686-4.686 4.686-12.284 0-16.971l-7.071-7.07c-4.686-4.686-12.284-4.686-16.97 0l-116.485 116c-4.686 4.686-4.686 12.284 0 16.971l116.485 116c4.686 4.686 12.284 4.686 16.97-.001z" /></svg><span className="mt-1">Back To Thumbnails (Press Esc)</span>
                                </button>
                            )}
                        </div>
                    )}
                    <div className="il-thumb-gallery">
                        <div>
                            {this.state.carouselIsOpen && (
                                <Fragment>
                                    <Swiper
                                        // className="mt-n1"
                                        modules={[Navigation]}
                                        navigation
                                        initialSlide={this.state.activeImageKey}
                                        slidesPerView={1}
                                        onActiveIndexChange={swiper => {
                                            this.setState({ activeImageKey: swiper.activeIndex });
                                        }}
                                        onAfterInit={swiper => {
                                            let images = swiper.el.querySelectorAll('.lazy-image');
                                            this.intersectObserver = lazyImages(images);
                                        }}
                                    >
                                        {this.state.images.map((img, key) => (
                                            <SwiperSlide
                                                key={key}
                                                className="d-flex justify-content-center align-items-center">
                                                <Image
                                                    spinner={true}
                                                    containerClasses="il-thumb-gallery-swiper-img d-block mx-auto"
                                                    imageClasses="il-thumb-gallery-swiper-img"
                                                    img={img}
                                                />
                                            </SwiperSlide>
                                        ))}

                                    </Swiper>
                                </Fragment>
                            )}
                            {!this.state.carouselIsOpen && !!this.state.images && (
                                <div className="row m-0">
                                    {this.state.images.map((img, key) => (
                                        <div
                                            key={key}
                                            id={`thumb-${key}`}
                                            className={classnames(
                                                "il-thumb-container p-0 position-relative",
                                                this.state.activeImageKey === key ? 'active' : null
                                            )}>
                                            <span className="position-absolute il-gallery-count p-2">{key + 1}</span>
                                            <picture>
                                                <source
                                                    type="image/webp"
                                                    srcSet={img.webp}
                                                    sizes="300px"
                                                />
                                                <source
                                                    type="image/jpeg"
                                                    srcSet={img.jpeg}
                                                    sizes="300px"
                                                />
                                                <img
                                                    className="w-100 h-100 object-contain bg-light pb-3"
                                                    width="300"
                                                    height="300"
                                                    alt={title}
                                                    src={img.src}
                                                    onClick={e => activateCarousel(key)}
                                                />
                                            </picture>
                                            {/* <img
                                                src={img.src}
                                                alt={title}
                                                loading="lazy"
                                                className="w-100 h-100 object-fit" /> */}
                                            {/* <Image
                                                key={key}
                                                id={`thumb-${key}`}
                                                containerClasses={classnames(
                                                    "il-thumb-container p-0",
                                                    this.state.activeImageKey === key ? 'active' : null
                                                )}
                                                imageClasses="w-100 h-100 lazy-image object-fit"
                                                img={img}
                                                onClick={e => activateCarousel(key)} /> */}
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        );
    }
}

export default GalleryModal;
